import { MembersPanel } from './MembersPanel';
import { AdminsPanel } from './AdminsPanel';
import { ImpersonatePanel } from './ImpersonatePanel';
import type { Role } from '../../lib/types';

// People: members, staff permissions, and impersonation in one place. The
// member table hands its email selection up via onComposeTo (the shell routes
// it to Comms -> Compose).

function cls(on: boolean) {
  return on ? 'admin__subpanel' : 'admin__subpanel admin__panel--hidden';
}

export function PeopleSection({
  tab,
  me,
  isDeveloper,
  canImpersonate,
  onComposeTo,
}: {
  tab: string;
  me: { id: string; role: Role };
  isDeveloper: boolean;
  canImpersonate: boolean;
  onComposeTo: (recipients: { email: string; display_name: string | null }[]) => void;
}) {
  return (
    <>
      <div className={cls(tab === 'members')}>
        <MembersPanel active={tab === 'members'} me={me} onComposeTo={onComposeTo} />
      </div>
      {isDeveloper && (
        <div className={cls(tab === 'admins')}>
          <AdminsPanel active={tab === 'admins'} meId={me.id} />
        </div>
      )}
      {canImpersonate && (
        <div className={cls(tab === 'impersonate')}>
          <ImpersonatePanel active={tab === 'impersonate'} isDeveloper={isDeveloper} />
        </div>
      )}
    </>
  );
}
